"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UploadEvent_1 = __importDefault(require("./UploadEvent"));
var UploadingState_1 = require("./UploadingState");
var DataroomMultipartUploadAdapter = /** @class */ (function () {
    function DataroomMultipartUploadAdapter(_a) {
        var url = _a.url, _b = _a.ssid, ssid = _b === void 0 ? null : _b;
        var _this = this;
        this.isCanceled = false;
        this.init = function (fileName, options) { return __awaiter(_this, void 0, void 0, function () {
            var reqParams, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isCanceled) {
                            return [2 /*return*/, Promise.resolve('')];
                        }
                        if (options.abortController) {
                            this.abortController = options.abortController;
                        }
                        reqParams = __assign({ method: 'POST', headers: __assign({ 'Content-Type': 'application/json', 'X-Dataroom-Id': options.dataroomId.toString() }, (this.ssid && { cookie: "ssid=".concat(this.ssid) })), body: JSON.stringify({ name: fileName, size: options.fileSize }), credentials: 'include' }, (this.abortController && { signal: this.abortController.signal }));
                        return [4 /*yield*/, fetch("".concat(this.url, "/init-upload"), reqParams)
                                .then(function (data) { return data.json(); })];
                    case 1:
                        result = _a.sent();
                        if (result.success !== true) {
                            throw { data: result };
                        }
                        return [2 /*return*/, result.data.id];
                }
            });
        }); };
        this.url = url;
        this.ssid = ssid;
    }
    DataroomMultipartUploadAdapter.prototype.upload = function (uuid, stream, fileSize, options) {
        var _this = this;
        var chunkNumber = 1;
        var uploadingState = new UploadingState_1.UploadingState(uuid, Math.ceil(fileSize / options.chunkSize));
        this.uploadingState = uploadingState;
        var activeChunkUploads = [];
        this.fileStream = stream;
        this.fileStream
            .on('data', function (chunk) { return __awaiter(_this, void 0, void 0, function () {
            var chunkUpload, removeCurrentChunk, e_1;
            var _this = this;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (this.isCanceled) {
                            return [2 /*return*/];
                        }
                        chunkUpload = this.uploadChunk({
                            chunkNumber: chunkNumber,
                            uploadId: uuid,
                            dataroomId: options.dataroomId,
                            totalChunks: uploadingState.totalChunks,
                            chunk: chunk,
                        });
                        removeCurrentChunk = function () {
                            activeChunkUploads = activeChunkUploads.filter(function (u) { return u !== chunkUpload; });
                        };
                        chunkUpload
                            .then(function () {
                            uploadingState.incrementSuccessfulChunks();
                            _this.eventEmitter.emit(UploadEvent_1.default.uploadChunkDone, uploadingState);
                            removeCurrentChunk();
                        })
                            .catch(function (error) {
                            var _a;
                            // @ts-ignore
                            (_a = _this.fileStream) === null || _a === void 0 ? void 0 : _a.destroy();
                            _this.eventEmitter.emit(UploadEvent_1.default.uploadChunkError, uploadingState.ERROR(error));
                            removeCurrentChunk();
                        });
                        activeChunkUploads.push(chunkUpload);
                        chunkNumber++;
                        if (!(activeChunkUploads.length >= 5)) return [3 /*break*/, 5];
                        // @ts-ignore
                        (_a = this.fileStream) === null || _a === void 0 ? void 0 : _a.pause();
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.any(activeChunkUploads)];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _d.sent();
                        if (uploadingState.error) {
                            return [2 /*return*/];
                        }
                        else {
                            uploadingState.ERROR(e_1);
                            this.eventEmitter.emit(UploadEvent_1.default.error, uploadingState);
                            // @ts-ignore
                            (_b = this.fileStream) === null || _b === void 0 ? void 0 : _b.destroy();
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        // @ts-ignore
                        (_c = this.fileStream) === null || _c === void 0 ? void 0 : _c.resume();
                        _d.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); })
            .on('end', function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (uploadingState.error) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.processUploadThreads(uuid, activeChunkUploads)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.combineChunksRequest({
                                uploadId: uuid,
                                dataroomId: options.dataroomId,
                                totalChunks: uploadingState.totalChunks,
                            })];
                    case 3:
                        _a.sent();
                        this.eventEmitter.emit(UploadEvent_1.default.uploadCombineChunksRequested, uploadingState);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        uploadingState.error = error_1;
                        this.eventEmitter.emit(UploadEvent_1.default.uploadCombineChunksRequestError, uploadingState);
                        return [2 /*return*/];
                    case 5:
                        this.eventEmitter.emit(UploadEvent_1.default.uploadDone, uploadingState.UPLOADED());
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * Process upload of chunks
     */
    DataroomMultipartUploadAdapter.prototype.processUploadThreads = function (uuid, uploads) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, Promise.all(uploads)];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        error_2 = _b.sent();
                        // @ts-ignore
                        (_a = this.fileStream) === null || _a === void 0 ? void 0 : _a.destroy();
                        return [2 /*return*/, error_2];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DataroomMultipartUploadAdapter.prototype.uploadChunk = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var reqParams, result, e_2;
            var chunkNumber = _b.chunkNumber, totalChunks = _b.totalChunks, chunk = _b.chunk, uploadId = _b.uploadId, dataroomId = _b.dataroomId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.isCanceled) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        reqParams = __assign(__assign({ method: 'POST', headers: __assign({ 'Content-Type': 'x-binary', 'X-Total-Chunks': totalChunks.toString(), 'X-Upload-Id': uploadId, 'X-Dataroom-Id': dataroomId.toString(), 'X-Current-Chunk': chunkNumber.toString() }, (this.ssid && { cookie: "ssid=".concat(this.ssid) })), body: chunk, credentials: 'include' }, (this.abortController && { signal: this.abortController.signal })), (typeof chunk.pipe === 'function' && { duplex: 'half' }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, fetch("".concat(this.url, "/save-chunk"), reqParams)];
                    case 2:
                        result = _c.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _c.sent();
                        return [4 /*yield*/, fetch("".concat(this.url, "/save-chunk"), reqParams)];
                    case 4:
                        // one retry
                        result = _c.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        if (result.status !== 200) {
                            throw { data: result };
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    DataroomMultipartUploadAdapter.prototype.combineChunksRequest = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var reqParams, result;
            var uploadId = _b.uploadId, dataroomId = _b.dataroomId, totalChunks = _b.totalChunks;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.isCanceled) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        reqParams = __assign({ method: 'POST', headers: __assign({ 'Content-Type': 'x-binary', 'X-Total-Chunks': totalChunks.toString(), 'X-Upload-Id': uploadId, 'X-Dataroom-Id': dataroomId.toString() }, (this.ssid && { cookie: "ssid=".concat(this.ssid) })), body: null, credentials: 'include' }, (this.abortController && { signal: this.abortController.signal }));
                        return [4 /*yield*/, fetch("".concat(this.url, "/join"), reqParams)];
                    case 1:
                        result = _c.sent();
                        if (result.status !== 200) {
                            throw { data: result };
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Pause stream reading
     */
    DataroomMultipartUploadAdapter.prototype.pause = function () {
        // @ts-ignore
        this.fileStream.pause();
    };
    /**
     * Resume stream reading
     */
    DataroomMultipartUploadAdapter.prototype.resume = function () {
        // @ts-ignore
        this.fileStream.resume();
    };
    /**
     * Cancel uploading
     */
    DataroomMultipartUploadAdapter.prototype.cancel = function () {
        var _a, _b;
        this.isCanceled = true;
        // @ts-ignore
        (_a = this.fileStream) === null || _a === void 0 ? void 0 : _a.destroy();
        (_b = this.abortController) === null || _b === void 0 ? void 0 : _b.abort();
        this.eventEmitter.emit(UploadEvent_1.default.cancel, this.uploadingState.CANCELLED());
    };
    DataroomMultipartUploadAdapter.prototype.setEventEmitter = function (eventEmitter) {
        this.eventEmitter = eventEmitter;
    };
    return DataroomMultipartUploadAdapter;
}());
exports.default = DataroomMultipartUploadAdapter;
//# sourceMappingURL=DataroomMultipartUploadAdapter.js.map